export interface ApiResponse<T> {
  data: T;
}

export interface PageMeta {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

export interface PagedResponse<T> {
  data: T[];
  meta: PageMeta;
}

export class ApiError extends Error {
  readonly status?: number;
  readonly code?: string;

  constructor(message: string, status?: number, code?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export const NETWORK_ERROR_MESSAGE =
  'Unable to reach the API. Check your connection and try again.';
export const DEFAULT_ERROR_MESSAGE = 'Request failed. Please try again.';
